import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import type { PostVO } from '../api/types';
import { formatDateChinese } from '../lib/format';

export default function PostCard({ post }: { post: PostVO }) {
  return (
    <Link to={`/blog/${post.slug}`} className="post-card">
      <h3 className="post-card-title">{post.title}</h3>
      {post.excerpt && <p className="post-card-excerpt">{post.excerpt}</p>}
      <div className="post-meta">
        <time dateTime={post.publishedAt ?? undefined}>
          {formatDateChinese(post.publishedAt)}
        </time>
        <span className="post-meta-dot" aria-hidden="true" />
        <span className="icon-inline">
          <Clock size={12} aria-hidden="true" />
          约 {post.readingTime} 分钟
        </span>
        {post.tags.length > 0 && (
          <>
            <span className="post-meta-dot" aria-hidden="true" />
            <span>{post.tags.join(' · ')}</span>
          </>
        )}
      </div>
    </Link>
  );
}
